/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["div.show[_ngcontent-%COMP%], div[_ngcontent-%COMP%]:first-child{display:block}div.hide[_ngcontent-%COMP%], div.none[_ngcontent-%COMP%]:first-child{display:none}"];
export { styles as styles };
